import { useReducer } from "react";
import {
  getCollaborators,
  getEventVisibility,
  leaveUserService,
  removeUserService,
  transferUserService,
} from "../../services/board";
import { CUSTOM_ROLES, ROLES } from "../../utils/constant";
import { optionProp } from "../../types";
import { EventSettingPayload } from "types/event.types";
import { updateEventSettings } from "services/event";

const initialArgs = {
  isShowSettingModal: false,
  searchQuery: "",
  initialEventPlanners: [],
  eventPlanners: [],
  options: CUSTOM_ROLES,
  selectedRole: [],
  settingData: {},
  selectedUser: null,
  selectedMember: null,
  selectedRemoveUser: null,
  eventData: {},
  selectedFeteAccess: "",
  isLoading: false,
  currentEventId: "",
  feteAccessOptions: [],
  currentUserId: null,
  showLeavePlanner: false,
  showOwnerModal: false,
  showRemoveUserModal: false,
  showTransferModal: false,
  updatedCollaborators: [],
  collaboratorsList: [],
  roles: []
};


const reducer = (state: any, action: any) => {
  return { ...state, ...action };
};

const useBoardHook = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const currentUser = JSON.parse(localStorage.getItem('userData') as string);
  if (currentUser && !state.currentUserId) {
    setState({
      ...state,
      currentUserId: currentUser.id
    })
  }

  const fetchFeteAccessOptions = async (id: any) => {
    try {
      const { data } = await getEventVisibility(id);
      const transformedData = data.map((item: any) => ({
        label: item.title,
        value: item.title.toLowerCase(),
        selected: item.selected,
        id: item._id,
        extraText:
          item.title === "Restricted"
            ? "only team admin and people invited to the fete can view"
            : "all members of the team can view",
      }));


      const result = transformedData.find((item: any) => item.selected);
      setState({
        ...state,
        selectedFeteAccess: result.value,
        feteAccessOptions: transformedData,
      });

      return transformedData;
    } catch (error) {
      console.log("Error fetching access options:", error);
    }
  };

  const fetchCollaborators = async (id: any) => {
    try {
      const { data } = await getCollaborators(id, state.searchQuery);

      const newTransformedData = data.map((item: any, index: any) => ({
        id: item._id,
        user_id: item.user_id,
        eventRoleId: item.eventRole._id,
        profileImage: "defaultProfile",
        name: item.user_name,
        email: item.user_email,
        teams: {
          roleName: item.eventRole.name,
          roleId: item.eventRole._id,
        },
      }));

      setState({
        ...state,
        eventPlanners: newTransformedData,
        initialEventPlanners: newTransformedData
      });
      return newTransformedData;
    } catch (error) {
      console.log("Error fetching access options:", error);
    }
  };

  const handleShowSettingModal = () => {
    setState({ ...state, isShowSettingModal: true });
  };

  const onCloseModal = () => {
    setState({ ...state, isShowSettingModal: false });
  };

  const handleInputChange = (query: string) => {
    setState({ ...state, searchQuery: query });
  };

  const handleChangeRole = (index: number, selectedVal: optionProp) => {
    const newDropdownValues = { ...state.selectedRole };
    newDropdownValues[index] = selectedVal;
    const updateData = [...state.eventPlanners];

    // updating the array on role change
    updateData[index].teams.roleName = selectedVal.value;
    updateData[index].teams.roleId = selectedVal.id;
    setState({
      ...state,
      selectedRole: newDropdownValues,
      eventPlanners: updateData,
    });
  };

  const handleRemove = (selectedMember: any) => {
    setState(
      {
        ...state, showRemoveUserModal: true,
        selectedMember: selectedMember  // thi
      })
  }

  const handleOptionChange = (event: any) => {
    setState({ ...state, selectedFeteAccess: event.target.value });
  };

  const getCurrentSelectedFeteAccessId = () => {
    const currentAccess = state.feteAccessOptions.find((accessOption: any) => accessOption['value'] === state.selectedFeteAccess);
    return currentAccess.id;
  }

  const resetStateToDefaults = () => {
    setState({ ...state, searchQuery: '', selectedRole: [] })
  }

  const handleSubmit = async (eventId: any) => {
    const payload: EventSettingPayload = {
      access_id: getCurrentSelectedFeteAccessId(),
      planners: state.eventPlanners.map((eventPlanner: any) => {
        return {
          user_id: eventPlanner.user_id,
          event_role_id: eventPlanner.teams.roleId
        }
      })
    };

    const currentEventId = state.currentEventId || eventId
    await updateEventSettings(currentEventId, payload);
    resetStateToDefaults();
    try {
      return;
    } catch (error) {
      console.log("Error while updating settings::", error);
    }
  };
  const getCollaboratorsRecord = async (id: string) => {
    try {
      const res = await getCollaborators(id, state.searchQuery);
      setState({ ...state, collaboratorsList: res.data })
    } catch (error) {
      console.log('Error while fetching the planner list =', error);
    }
  }

  const LeaveUser = async (id: string, payload: any) => {
    try {
      const res = await leaveUserService(id, payload)
    } catch (error) {
      console.log('Error while leave user', error);
    }
  }

  const removeUser = async (id: string, payload: any) => {
    try {
      const res = await removeUserService(id, payload)
    } catch (error) {
      console.log('Error while remove user', error);
    }
  }

  const transferUser = async (id: string, payload: any) => {
    try {
      const res = await transferUserService(id, payload)
      setState({ ...state, isShowSettingModal: false })
      return res;
    } catch (error) {
      console.log('Error while transfer owner =', error);
    }
  }

  const updateSetState = (payload: any) => {
    setState({ ...state, ...payload });
  };

  return {
    handleShowSettingModal,
    handleInputChange,
    handleChangeRole,
    onCloseModal,
    handleOptionChange,
    handleRemove,
    fetchFeteAccessOptions,
    handleSubmit,
    updateSetState,
    fetchCollaborators,
    getCollaboratorsRecord,
    LeaveUser,
    removeUser,
    transferUser,
    resetStateToDefaults,
    setState,
    ...state,
  };
};;
export default useBoardHook;
